import PropTypes from 'prop-types';
import useAsync from '../../hooks/useAsync';
import bureaucrat from '../../util/Bureaucrat';
import BillingProfileForm from './BillingProfileForm';
import useRequireAuth from '../../hooks/useRequireAuth';

function UpdateBillingProfile({ onComplete }) {
  useRequireAuth();
  const { status, value } = useAsync(bureaucrat.getBillingProfile, true);

  return (
    status === 'success' && (
      <BillingProfileForm
        data={value}
        onComplete={onComplete}
        onCancel={onComplete}
      />
    )
  );
}

UpdateBillingProfile.propTypes = {
  onComplete: PropTypes.func,
};
export default UpdateBillingProfile;
